import { FILECHECK_PREFIX } from "@pdfking/constants/settings"
import { startswith } from "@pdfking/workflow/utils/strings"
import guess_filename from "./guess_filename"

export default (name: string): boolean =>
  startswith(guess_filename(name) || "", FILECHECK_PREFIX)
